import { FunctionComponent } from 'react';
import { TypeNewsletterBannerProps } from './types';
import Image from 'next/image';
import Button from '../button';
import { ButtonVariant } from '../button/types';
import { showNewsletterPopUp } from '@/lib/newsletterPopUp';
import { useDispatch } from 'react-redux';

export const NewsletterBanner: FunctionComponent<TypeNewsletterBannerProps> = ({
}: TypeNewsletterBannerProps) => {
    const dispatch = useDispatch();
    return (
        <div className="border border-primary-500 p-4 md:p-6 rounded-lg flex flex-col items-center justify-between max-w-sm mx-auto">
            <p className="text-subtitle text-subtitle--l my-0 text-center">- 10 € EN TU PRIMERA COMPRA</p>
            <Image className='my-0 max-w-[200px]' src="/assets/images/productos/4estaciones/jamon_4_estaciones_large.webp" width={200} height={200} alt="newsletter image" />
            <Button variant={ButtonVariant.PRIMARY} onClick={() => dispatch(showNewsletterPopUp(""))}>
                Consíguelo
            </Button>
        </div>
    );
};

NewsletterBanner.displayName = 'NewsletterBanner';
